import { Component } from '@angular/core';

@Component({
  selector: 'internal-chat-main-frame',
  templateUrl: './main-frame.component.html',
  styleUrls: ['./main-frame.component.scss']
})
export class MainFrameComponent {}
